module.exports = __webpack_public_path__ + "img/erweima1.5410de4d.png";